import React from 'react';

import { RoundedRectIndicator } from '../../../components/indicators/RoundedRectIndicator';
import type { LearningRule } from '../types';

interface LearningRuleIndicatorProps {
  rule: LearningRule;
  isHovered: boolean;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
}

export const LearningRuleIndicator: React.FC<LearningRuleIndicatorProps> = ({
  rule,
  isHovered,
  onMouseEnter,
  onMouseLeave,
}) => {
  return (
    <RoundedRectIndicator
      width={12}
      height={12}
      borderRadius="50%"
      bgcolor={isHovered ? 'borderColors.brand' : 'backgroundColors.secondary'}
      borderColor={isHovered ? 'borderColors.brand' : 'borderColors.primary'}
      hoverBgcolor="borderColors.brand"
      hoverBorderColor="borderColors.brand"
      hoverScale={1.15}
      isHovered={isHovered}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      aria-label={`Learning rule: ${rule.title}`}
    />
  );
};


